import React, { Children, useContext, useEffect, useState } from "react";

import Cookies from "universal-cookie";




import { useDispatch } from "react-redux";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import RefreshToken from "utils/RefreshToken";
import { AuthContext } from "contexts/auth-context";
// import { RefreshToken } from 'Connect/RefreshToken';

const RefreshTokenComponent = () => {
  const [refreshTokenLoading, setRefreshTokenLoading] = useState(false)
  const [nowTime, setNowTime] = useState(0)
  const navigate = useNavigate()
  const ctx = useContext(AuthContext);
  const cookies = new Cookies();

  const originalText = parseInt(cookies.get('expireTime'))

  useEffect(() => {

    setTimeout(() => {

      if (!originalText) {


        navigate({ pathname: "/" })

      }
    }, 1000);
  }, [])
  useEffect(() => {


    const reload1 = () => {
      const now = new Date();
      setNowTime(now.getTime() / 1000)
      // console.log(originalText)
      // console.log( nowTime)
      // console.log(originalText - nowTime)
      if (originalText && (originalText - nowTime) < 0 && !refreshTokenLoading) {
        setRefreshTokenLoading(true)
        RefreshToken().then(async (res) => {
          ctx.updateToken(res)
          setRefreshTokenLoading(false)
        }).catch(() => {
          ctx.handleLogout()
          setRefreshTokenLoading(false)

        });
      }
    }
    var toReload1 = setInterval(reload1, 1000);
    setTimeout(() => {
      clearInterval(toReload1)
    }, 1000);
  }, [nowTime])


  return (
    <>
      {refreshTokenLoading && <div className={"refreshTokenSpin"}>
        <Spin size="large" spinning={true} />
        <p className=" t5 white100">لطفا کمی صبر کنید</p>
      </div>
      }
    </>
  )
}
export default React.memo(RefreshTokenComponent)